import { themeColors } from "../../config.js";
export const listStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "stretch",
  },
  entry: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
  },
  input: {
    fontSize: 15,
    borderRadius: 5,
    flex: 1,
    fontFamily: "roboto",
    textShadow: "0 0 5px white",
    padding: 2,
    outline: "none",
    border: "none",
    backgroundColor: themeColors.transparentBlack,
    color: themeColors.optionTextColor,
  },
};
